var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import isPropValid from '@emotion/is-prop-valid';
import styled from '../../../../styles/styled';
import { useClickEvent } from '../../../../hooks/useClickEvent';
import { useComponents } from '../../../ComponentsContext';
import { getIcon } from '../../SidebarService';
import { NavLabel } from '../NavLabel';
const baseStyles = ({ theme }) => css `
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: auto;
  margin: ${theme.spacings.mega};
  padding: ${theme.spacings.bit};
  cursor: pointer;
  color: ${theme.colors.n300};
  text-decoration: none;
  transition: color ${theme.transitions.default};
`;
const secondaryStyles = ({ theme, secondary }) => secondary &&
    css `
    margin: 0px ${theme.spacings.giga};
    padding: ${theme.spacings.bit} 0px;
    transition: color ${theme.transitions.default},
      top ${theme.transitions.default};
  `;
const hoverStyles = ({ theme, selected, disabled, }) => !disabled &&
    !selected &&
    css `
    &:hover {
      color: ${theme.colors.n100};
    }
  `;
const selectedStyles = ({ theme, selected }) => selected &&
    css `
    font-weight: ${theme.fontWeight.bold};
    color: ${theme.colors.white};
  `;
const disabledStyles = ({ theme, disabled }) => disabled &&
    css `
    cursor: not-allowed;
    color: ${theme.colors.n500};
  `;
const NavLink = styled('a', {
    shouldForwardProp: isPropValid,
})(baseStyles, hoverStyles, selectedStyles, secondaryStyles, disabledStyles);
export function NavItem(_a) {
    var { label, secondary = false, visible = true, defaultIcon, selectedIcon, selected = false, disabled = false, onClick, tracking } = _a, props = __rest(_a, ["label", "secondary", "visible", "defaultIcon", "selectedIcon", "selected", "disabled", "onClick", "tracking"]);
    const { Link } = useComponents();
    const handleClick = useClickEvent(onClick, tracking, 'sidebar-nav-item');
    const icon = getIcon({ defaultIcon, selected, selectedIcon, disabled });
    return (_jsx("li", Object.assign({ css: css `
        /* the default display: list-item breaks spacing on Safari */
        display: block;
      ` }, { children: _jsxs(NavLink, Object.assign({ as: Link, onClick: !disabled ? handleClick : undefined, selected: selected, secondary: secondary, visible: visible, disabled: disabled }, props, { children: [icon, _jsx(NavLabel, Object.assign({ secondary: secondary, visible: visible }, { children: label }))] })) })));
}
